var url = {
  // api: 'http://47.103.10.23:9553/' // 测试环境
  // api: 'https://47.103.10.23/'
  api: 'https://hszx.hsqh.net/' // 正式环境
}
export default url



// WEBPACK FOOTER //
// ./src/config/url.js